import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AuthShell } from "@/pages/Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  if (!token) return <AuthShell title="Invalid link" subtitle="This reset link is missing or invalid."><Link to="/forgot-password" className="text-amber font-semibold">Request a new link</Link></AuthShell>;

  return (
    <AuthShell title="Set a new password" subtitle="Choose a new password for your account.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="password">New password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="mt-1" placeholder="At least 6 characters" />
        </div>
        <Button type="submit" disabled={busy} data-testid="reset-submit" className="w-full rounded-full bg-amber hover:bg-amber-600 text-white font-semibold">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
        </Button>
      </form>
    </AuthShell>
  );
}
